import { render } from "./importWeChat.vue?vue&type=template&id=0935a86a"
import script from "./importWeChat.vue?vue&type=script&lang=js"
export * from "./importWeChat.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/userCenter/userManage/components/importWeChat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0935a86a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0935a86a', __exports__)) {
    console.log('reload')
    api.reload('0935a86a', __exports__)
  }
  
  module.hot.accept("./importWeChat.vue?vue&type=template&id=0935a86a", () => {
    console.log('re-render')
    api.rerender('0935a86a', render)
  })

}


export default __exports__